import {useState} from "react";

import {fromJsonValues} from "../../form/translate/from_json_values";
import {searchFormFields} from "../constants/search_form_constants";
import {SearchFormValuesType} from "../types/SearchFormValuesType";

interface IUseFilterProps {
    closeMobileFilterModal: () => void;
    onAfterChange: () => void;
    onSubmit: (formValues: SearchFormValuesType) => void;
    formValues: SearchFormValuesType;
}
const useFilter = (props: IUseFilterProps) => {
    const {closeMobileFilterModal, onAfterChange, onSubmit} = props;
    const [isDrawerOpen, setDrawerOpen] = useState(false);

    const closeDrawer = () => setDrawerOpen(false);

    const resetFilters = () => {
        onSubmit({
            ...(fromJsonValues(searchFormFields, {distance: 5}) as SearchFormValuesType),
            search: props.formValues.search
        });
        closeMobileFilterModal();
        closeDrawer();
        onAfterChange();
    };

    return {
        isDrawerOpen,
        setDrawerOpen,
        closeDrawer,
        resetFilters
    };
};

export default useFilter;
import {useState} from "react";

import {fromJsonValues} from "../../form/translate/from_json_values";
import {searchFormFields} from "../constants/search_form_constants";
import {SearchFormValuesType} from "../types/SearchFormValuesType";

interface IUseFilterProps {
    closeMobileFilterModal: () => void;
    onAfterChange: () => void;
    onSubmit: (formValues: SearchFormValuesType) => void;
    formValues: SearchFormValuesType;
}
const useFilter = (props: IUseFilterProps) => {
    const {closeMobileFilterModal, onAfterChange, onSubmit} = props;
    const [isDrawerOpen, setDrawerOpen] = useState(false);

    const closeDrawer = () => setDrawerOpen(false);

    const resetFilters = () => {
        onSubmit({
            ...(fromJsonValues(searchFormFields, {distance: 5}) as SearchFormValuesType),
            search: props.formValues.search
        });
        closeMobileFilterModal();
        closeDrawer();
        onAfterChange();
    };

    return {
        isDrawerOpen,
        setDrawerOpen,
        closeDrawer,
        resetFilters
    };
};

export default useFilter;
